<template>
<v-card>
  <v-card-title class='overline' >
    <v-btn small :loading='requests.configure.loading' @click='get' icon ><v-icon small>replay</v-icon></v-btn>
    Configure Physitrack
    <v-spacer></v-spacer>
    <v-chip v-if='requests.test.status === 200' small color='success' dark>
      <v-avatar left>
        <v-icon small>check_circle</v-icon>
      </v-avatar>
      Connected
    </v-chip>
    <v-chip
      @click='testConnection'
      v-else-if='requests.test.status >= 400' small color='error' dark>
      <v-avatar left>
        <v-icon small>warning</v-icon>
      </v-avatar>
      Connection error
    </v-chip>
    <v-btn
      @click='testConnection'
      :loading='requests.test.loading'
      :disabled='configureRequestStatus !== 200' small>Test connection</v-btn>
  </v-card-title>
  <request-status
    :request='requests.configure'
    message204='Successfully uninstalled'
    message404='Currently not installed'
    message201='Integration installed successfully' >
  </request-status>
  <v-card-text>
    <v-layout row wrap >
      <v-flex xs12>
      <v-alert class='mb-4' color='warning' outline card :value='true' v-if='agToken' xs12>
        <strong>Discount code:</strong> <code>AGPT2020</code><br/>
        You can use this discount code to get a 20% discount off your monthly Physitrack subscription<br/>
        You can enter the code in Physitrack: account -> subscription
      </v-alert>

      <v-alert type='info' :value='true' v-if='agToken' xs12>
        <v-subheader class='overline pl-0' dark>Your AppointmentGuru API Key</v-subheader >
        <copy-text-field dark
          label='Your AppointmentGuru API key'
          :text-to-copy='agToken' >
        </copy-text-field>
        <!-- </copy-text-field>
        <v-text-field readonly
          v-model='agToken'
          label='Your AppointmentGuru API key' >
        </v-text-field> -->
        <small>
          <strong>In Physitrack</strong>, account -> settings under the <strong>Integrations</strong>
          heading:
          <ol>
            <li>"Synchronize my client data from:" Choose AppointmentGuru</li>
            <li>Paste the key above for the API key</li>
          </ol>
          Once you've done this, click <strong>test connection</strong> to verify that the integration is properly installed
        </small>
      </v-alert>
      </v-flex>
      <v-flex class='mt-4' xs12>
        <v-text-field v-model='physitrackToken'
          :error-messages='formErrors.service_user_id'
          label='Your physitrack token' >
        </v-text-field>
        <small>
          <strong>In Physitrack</strong>, account -> settings under the <strong>API</strong> heading
          Make sure "Enable API access to my account" is selected and paste the API key here.<br/>
          <strong>Tip:</strong> Your API key will look something like this:
          <code>bb4a74001fde53c1d3847687462fb070d57eddbd0e31343f66a93c0d429a5669</code>
        </small>
      </v-flex>
      <v-flex class='mt-4' xs12>
        <v-text-field
          label='Physitrack url (datacenter)'
          prefix='https://' suffix='physitrack.com'
          v-model='datacenter' >
        </v-text-field>
        <small>
          When you are logged in to Physitrack and you look at the URL, what do you see just before `physitrack.com`.
          If nothing (e.g.: your url is https://physitrack.com) use <strong>us</strong><br/>
          Common options are: <strong>us</strong>, <strong>uk</strong>
        </small>
      </v-flex>
    </v-layout>
  </v-card-text>
  <v-divider></v-divider>
  <v-card-actions class='mt-4' >
    <v-dialog :width='320' v-model='showuninstall' >
        <v-card>
          <v-card-title class='overline' >
            Are you sure you want to unintsall the Physitrack integration?
          </v-card-title>
          <v-card-text>
          </v-card-text>
          <v-card-actions >
            <v-btn @click='showuninstall=false' flat text >Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn @click='uninstall' :loading='requests.delete.loading' color='error' >
              Uninstall Physitrack
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-btn
        @click='showuninstall=true'
        :loading='requests.delete.loading' color='error' >
        Uninstall</v-btn>
    <v-spacer ></v-spacer>
    <v-btn @click='configure' :loading='requests.configure.loading' color='primary' >Save</v-btn>
  </v-card-actions>
</v-card>
</template>
<script>
import Vue from 'vue'
import CopyTextField from '@/components/ui/CopyTextField'
import RequestStatus from '@/components/ui/RequestStatus'

export default {
  name: 'PhysitrackConfiguration',
  components: {CopyTextField, RequestStatus},
  data () {
    return {
      agToken: '',
      physitrackToken: '',
      datacenter: 'uk',
      showuninstall: false,
      updating: false,
      requests: {
        configure: {
          resource: 'ag.integrations',
          extra: 'physitrack/configure',
          status: 0
        },
        delete: {
          resource: 'ag.integrations',
          extra: 'physitrack/delete'
        },
        test: {
          resource: 'ag.integrations',
          extra: 'physitrack/clients',
          status: 0
        }
      }
    }
  },
  mounted () {
    this.get()
  },
  watch: {
    configureRequestStatus () {
      if (this.configureRequestStatus === 200) {
        this.physitrackToken = this.getObjectPath(this.requests, 'configure.result.service_user_id')
        this.agToken = this.getObjectPath(this.requests, 'configure.result.token')
        this.datacebter = this.getObjectPath(this.requests, 'configure.result.settings.datacenter', '')
        this.testConnection()
        if (this.updating) {
          this.getLookups()
          this.updating = false
        }
      }
      if (this.configureRequestStatus === 404) {
      }
    },
    deleteStatus () {
      if (this.deleteStatus === 204) {
        Vue.set(this.requests, 'configure.result', {})
        this.get()
        this.physitrackToken = null
        this.agToken = null
        this.showuninstall = false
        this.requests.configure.status = 0
      }
    }
  },
  methods: {
    get () {
      this.$request('get', this.requests.configure)
    },
    uninstall () {
      this.$request('delete', this.requests.delete)
    },
    testConnection () {
      this.$request('get', this.requests.test)
    },
    configure () {
      this.updating = true
      this.requests.configure.data = {
        service_user_id: this.physitrackToken,
        datacenter: this.datacenter
      }
      this.$request('save', this.requests.configure)
    }
  },
  computed: {
    configureRequestStatus () {
      return this.requests.configure.status
    },
    deleteStatus () {
      return this.getObjectPath(this.requests, 'delete.status', 0)
    },
    formErrors () {
      return this.getObjectPath(this.requests, 'configure.errors', {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?913170be